var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{ref:"list",attrs:{"search-btn":false,"tableTitle":_vm.tableTitle,"search-time":false,"searchBtn":false,"searchUrl":_vm.url,"form":_vm.form,"back":_vm.back,"delete-url":_vm.deleteUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }